import React, { useRef } from 'react'
import { ChangeContractBinForm, formFieldNames } from '@/entity/contracts'
import { ModalTemplate } from '@/ui'
import styles from './style.module.scss'
import { contractsActions } from '@/entity'
import { useDispatch } from 'react-redux'

export const ChangeBinForm = ({
	initialValues,
	options = {},
	onSubmit,
	onGetHandBookOptions,
	onCancel,
	setIsEsutd,
}) => {
	const formRef = useRef(null)
	const dispatch = useDispatch()

	const handleClose = () => {
		dispatch(contractsActions.clearDataByBin())
		onCancel()
	}

	return (
		<ModalTemplate onClose={handleClose}>
			<div className={`scroll ${styles.wrapper}`}>
				<ChangeContractBinForm
					options={options}
					initialValues={initialValues}
					advanced
					onSubmit={onSubmit}
					onGetHandBookOptions={onGetHandBookOptions}
					onClose={handleClose}
					formRef={formRef}
					isTitle
					setIsEsutd={setIsEsutd}
				/>
			</div>
		</ModalTemplate>
	)
}
